// extracted by mini-css-extract-plugin
module.exports = {"link":"FreePlanRestriction__link--BGcEz"};